export default __webpack_public_path__ + "static/media/cs-a009-1.4f39f742.svg";